import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { AppSettingsService } from '../config/config-service';

@Injectable({
  providedIn: 'root'
})
export class EncryptionService {
  constructor(private appSettings: AppSettingsService) { }

  /**
   * Encrypts a password using AES-256-CBC for the backend API.
   * - Reads key/iv from runtime config (Angular environment via AppSettingsService)
   * - Returns ciphertext in hex format
   * @param plainTextPassword The user's plain-text password.
   */
  encryptPassword(plainTextPassword: string): string {
    const { cryptoSecretKey, cryptoIv } = this.appSettings.getSettings();

    if (!cryptoSecretKey || !cryptoIv) {
      throw new Error('Encryption keys are not configured. Please set cryptoSecretKey and cryptoIv in the environment config.');
    }

    if (cryptoSecretKey.length !== 64 || cryptoIv.length !== 32) {
      throw new Error('Invalid encryption key/IV length. Expected 64 hex chars for key (32 bytes) and 32 hex chars for IV (16 bytes).');
    }

    const key = CryptoJS.enc.Hex.parse(cryptoSecretKey);
    const iv = CryptoJS.enc.Hex.parse(cryptoIv);

    const encrypted = CryptoJS.AES.encrypt(plainTextPassword, key, {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    // Return the ciphertext in hex format, which the backend expects
    return encrypted.ciphertext.toString(CryptoJS.enc.Hex);
  }
}